export default "__VITE_PUBLIC_ASSET__a6ed0145__"